import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import stores from '@/common/utils/stores';

export default function LanguageSelect() {
  const { t, i18n } = useTranslation();
  const language = i18n.language?.startsWith('en') ? 'en' : 'zh';

  const changeLanguage = value => {
    stores.saveLocalStorage('languageType', value);
    i18n.changeLanguage(value);
  };

  return (
    <Select
      aria-label={t('menu_language')}
      value={language}
      onChange={changeLanguage}
      options={[
        { value: 'zh', label: '简体中文' },
        { value: 'en', label: 'English' },
      ]}
    />
  );
}
